const zeroPad = (num, places) => String(num).padStart(places, '0')

export default {
  methods: {
    formatDurationMs: function (ms, human = false, roundToSeconds = false) {
      if (ms < 0) ms = -ms;
      
      const days = Math.floor(ms / 86400000);
      const hours = Math.floor(ms / 3600000) % 24;
      const minutes = Math.floor(ms / 60000) % 60;
      var seconds = Math.floor(ms / 1000) % 60;
      const milliseconds = Math.floor(ms) % 1000;

      if (roundToSeconds)
        seconds = seconds + (milliseconds > 500 ? 1 : 0);
    
      if (human)
        return (
          (
            days == 0
              ? ""
              : days == 1
                ? days + " day"
                : days + " days"
          ) + (days > 0 && hours > 0 ? ", " : "") +
          (
            hours == 0
              ? ""
              : hours == 1
                ? hours + " hour"
                : hours + " hours"
          ) + (hours > 0 && minutes > 0 ? ", " : "") +
          (
            minutes == 0
              ? ""
              : minutes == 1
                ? minutes + " min"
                : minutes + " mins"
          ) + (minutes > 0 && seconds > 0 ? ", " : "") +
          (
            seconds == 0
              ? ""
              : seconds == 1
                ? seconds + " sec"
                : seconds + " secs"
          ) + (seconds > 0 && milliseconds > 0 && !roundToSeconds ? ", " : "") +
          (roundToSeconds || milliseconds <= 0 ? "" : (milliseconds + " msec")) 
        );
      else
        return (
          zeroPad(days * 24 + hours, 2) + ':' +
          zeroPad(minutes, 2) + ':' +
          zeroPad(seconds, 2) + 
          (roundToSeconds ? "" : "." + zeroPad(milliseconds, 3))
        );
    }
  }
};
